import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-labelledby"]
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "modal-tab"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "modal-info"
}
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled", "onClick"]

import {
  computed,
  CSSProperties,
  ref,
} from "vue";

//  Types
export type ActionSpec = {
  id: string;
  label: string;
  icon?: string;
  variant?: "primary" | "secondary" | "danger" | "ghost";
  class?: string;
  disabled?: boolean;
};

// --- Props ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    id: {},
    title: { default: "" },
    info: { default: "" },
    modalClass: { default: "" },
    actions: { default: () => [] },
    actionAlign: { default: "end" },
    actionsGap: { default: "10px" },
    closable: { type: Boolean, default: true },
    overlayClosable: { type: Boolean, default: false },
    escClosable: { type: Boolean, default: true },
    noWrap: { default: "nowrap" },
    showTab: { type: Boolean, default: true }
  },
  emits: ["action", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// ---- Constants & Variables ------------------------------
const title = ref(props.title);
const titleId = computed(() => `${props.id}-title`);
//  notify Event
const emit = __emit;

// ---- Functions -----------------------------------------
function emitAction(id: string, label?: string, event?: MouseEvent) {
  // 親でidを元に分岐させて処理する
  emit("action", { id, label, nativeEvent: event as MouseEvent });
}

function emitClose(nativeEvent?: Event) {
  emit("close", { nativeEvent });
}

// ---- Vue Lifecycle Hooks ----------------------------------
const actionButtonStyle = computed<CSSProperties>(() => {
  const map: Record<
    "start" | "center" | "end" | "space-between",
    CSSProperties["justifyContent"]
  > = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    "space-between": "space-between",
  };
  return {
    justifyContent: map[props.actionAlign],
    gap: props.actionsGap,
    display: "flex",
    alignItems: "center",
    flexWrap: props.noWrap,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      id: _ctx.id,
      class: "modal-root"
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(['modal', _ctx.modalClass]),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": titleId.value
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("div", {
              class: "modal-header-title",
              id: titleId.value
            }, _toDisplayString(title.value), 9, _hoisted_4),
            (_ctx.closable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "modal-close",
                  "aria-label": "Close modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emitClose($event)))
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.showTab)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _renderSlot(_ctx.$slots, "tabInfo")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.info)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.info) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  src: "/server/necs/images/icon_info.svg",
                  alt: "情報"
                }, null, -1))
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "bodyInfo")
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footerHeader"),
          _createElementVNode("div", {
            class: "modal-footer-buttons",
            style: _normalizeStyle(actionButtonStyle.value)
          }, [
            _renderSlot(_ctx.$slots, "footerButton", { emitAction: emitAction }, () => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (btn) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: btn.id,
                  class: _normalizeClass(["btn", ['btn-' + (btn.variant ?? 'secondary'), btn.class]]),
                  disabled: btn.disabled,
                  onClick: ($event: any) => (emitAction(btn.id, btn.label, $event))
                }, [
                  (btn.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(btn.icon),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(btn.label), 1)
                ], 10, _hoisted_9))
              }), 128))
            ])
          ], 4)
        ])
      ], 10, _hoisted_2)
    ], 8, _hoisted_1)
  ]))
}
}

})